import React from "react";
import ErrorBoundary, { FallbackProps } from "react-error-boundary";
import { appInsights } from "../services/telemetry.service";
import { SnackbarProvider } from "notistack";

interface BasePageWrapperProps {
	// render function to render a dynamic component
	children: JSX.Element;
}

const globalErrorHandler = (error: Error, componentStack: string) => {
	appInsights.trackException({ exception: error, properties: { componentStack } });
};

/**
 * Base page component that encapsulates common functionality for all pages
 * @param props
 */
export const BasePageWrapper = (props: BasePageWrapperProps) => {
	return (
		<ErrorBoundary
			key={Math.random()} // We want this component to re-render and this is the way suggested here: https://github.com/bvaughn/react-error-boundary/issues/23
			onError={globalErrorHandler}
			FallbackComponent={(errorInfo: FallbackProps) => (
				<div>An unexpected error occurred: {errorInfo.error && errorInfo.error.toString()}</div>
			)}
		>
			<SnackbarProvider>{props.children}</SnackbarProvider>
		</ErrorBoundary>
	);
};
